import { AlgoliaProductHit } from '../../utils/types';
import { useProducts } from '@jbhi-fi/components/src/hooks/useProducts/useProducts';
import { productClientNonFamily } from '../../api/algolia/ProductClient';

// export const useProductsWithSplitFamilies = (
//   hits: Array<AlgoliaProductHit>,
//   shouldSplitTiles?: boolean
// ): Array<AlgoliaProductHit> => {
export const useProductsWithSplitFamilies = ({
  hits,
  shouldSplitTiles,
}: {
  hits: Array<AlgoliaProductHit>;
  shouldSplitTiles?: boolean;
}): Array<AlgoliaProductHit> => {
  const allFamilySkus = hits.filter(hit => hit.keepSplit === false).flatMap(hit => hit.skus);
  const { products = [] } = useProducts({
    productSkus: allFamilySkus,
    isEnabled: allFamilySkus.length > 0 && shouldSplitTiles,
    productClient: productClientNonFamily,
  });

  const hitsWithChildVariants = [...hits];
  products.forEach(product => {
    const index = hits.findIndex(hit => hit.skus?.includes(product.sku));
    hitsWithChildVariants.splice(index, 0, product);
  });
  const hitsWithSplitFamilies = hitsWithChildVariants.filter(hit => !hit.is_family);
  const allHits = shouldSplitTiles ? hitsWithSplitFamilies : hits;

  return allHits;
};
